function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgSearch = function SvgSearch(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Search' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("path", {
    d: "M16.963,1.926 C8.671,1.926 1.926,8.671 1.926,16.963 C1.926,25.254 8.671,32 16.963,32 C25.255,32 32,25.254 32,16.963 C32,8.671 25.255,1.926 16.963,1.926 L16.963,1.926 Z M46.282,47.644 L28.252,29.614 C25.251,32.294 21.294,33.926 16.963,33.926 C7.609,33.926 0,26.316 0,16.963 C0,7.609 7.609,0 16.963,0 C26.317,0 33.926,7.609 33.926,16.963 C33.926,21.294 32.294,25.251 29.614,28.252 L47.644,46.282 L46.282,47.644 Z"
  }));
};

SvgSearch = pure(SvgSearch);
SvgSearch.displayName = 'SvgSearch';
export default SvgSearch;